import {StoreStateShape} from '@/redux/store/storeStateTypes';

const selectScheduleTrackerRequestsCount = ({
    commonScheduleTrackerReducer: {scheduleTrackerRequestsCount},
}: StoreStateShape) => scheduleTrackerRequestsCount;

export {selectScheduleTrackerRequestsCount};
